import React, {useEffect, Fragment, useState} from 'react';
import {connect} from "react-redux";
import sqftSlabManager from "./canvas/store/sqftSlabManager";
import SlabWorkspace from "./canvas/core/slab/slabWorkspace";

const SqftFooterActiveShapeColorset = (props) => {
  const {isShowSlabTool} = props;

  const [colorSet, setActiveColorSet] = useState(null);


  useEffect(() => {
    const handleShapeOffsetChange = () => {
      const activeShapeWithOffset = SlabWorkspace.getShapeOffset();
      if (!activeShapeWithOffset) {
        setActiveColorSet(null);
      } else {
        const activeShape = activeShapeWithOffset.getParent();
        const colorSet = activeShape.getColorSet();
        setActiveColorSet(colorSet);
      }
    };

    sqftSlabManager.on('shapeOffsetChanged', handleShapeOffsetChange);

    return () => {
      sqftSlabManager.off('shapeOffsetChanged', handleShapeOffsetChange);
    };
  }, []);

  if (!colorSet) {
    return null
  }

  return (
    <Fragment>
      {
        isShowSlabTool ?
          <div className="eq">
            <div className="info-colorset__rect" style={{
              backgroundColor: colorSet.primary,
              border: '1px solid' + colorSet.primary_border
            }}>

            </div>
            <div className="">
              { colorSet.featureName }
            </div>
          </div>
        : ""
      }
    </Fragment>
  )
};

const mapStateToProps = (store) => ({
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
});

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftFooterActiveShapeColorset);
